var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _vm.canEdit("first_name")
            ? _c(
                "el-form-item",
                { attrs: { label: "First Name", prop: "first_name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.first_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "first_name", $$v)
                      },
                      expression: "form.first_name",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canEdit("last_name")
            ? _c(
                "el-form-item",
                { attrs: { label: "Last Name", prop: "last_name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.last_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "last_name", $$v)
                      },
                      expression: "form.last_name",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canEdit("status")
            ? _c(
                "el-form-item",
                { attrs: { prop: "status", label: "Status", required: true } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function ({ label, value }) {
                      return _c("el-option", {
                        key: value,
                        attrs: { label: label, value: value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPhoneNumberEditable
            ? _c(
                "el-form-item",
                { attrs: { label: "Phone number", prop: "phone_number" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.phone_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone_number", $$v)
                      },
                      expression: "form.phone_number",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canEdit("email")
            ? _c(
                "el-form-item",
                { attrs: { label: "Email", prop: "email" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canEdit("email_context")
            ? _c(
                "el-form-item",
                { attrs: { label: "Email context", prop: "email_context" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.email_context,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email_context", $$v)
                      },
                      expression: "form.email_context",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canEdit("filemaker_id")
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Filemaker ID",
                    prop: "filemaker_id",
                    required: true,
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.filemaker_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "filemaker_id", $$v)
                      },
                      expression: "form.filemaker_id",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-purple px-4", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }